import { callCoreApi } from "./coreApi";

function resolveClockInAt(payload) {
	return (
		payload?.entry?.clock_in_at ||
		payload?.entry?.clockInAt ||
		payload?.clock_in_at ||
		payload?.clockInAt ||
		null
	);
}

export async function getMyClockStatus() {
	const payload = await callCoreApi("/api/time-clock/me/status", {
		method: "GET",
	});

	return {
		isClockedIn: Boolean(payload?.is_clocked_in),
		clockInAt: resolveClockInAt(payload),
		entry: payload?.entry || null,
		elapsedSeconds: Number(payload?.elapsed_seconds || 0),
	};
}

export async function clockIn() {
	const payload = await callCoreApi("/api/time-clock/clock-in", {
		method: "POST",
		body: {},
	});

	return {
		isClockedIn: Boolean(payload?.is_clocked_in),
		clockInAt: resolveClockInAt(payload),
		entry: payload?.entry || null,
		elapsedSeconds: Number(payload?.elapsed_seconds || 0),
	};
}

export async function clockOut(workedOn = "") {
	const trimmedWorkedOn = String(workedOn || "").trim();
	const body = trimmedWorkedOn ? { worked_on: trimmedWorkedOn } : {};

	const payload = await callCoreApi("/api/time-clock/clock-out", {
		method: "POST",
		body,
	});

	return {
		isClockedIn: Boolean(payload?.is_clocked_in),
		clockInAt: resolveClockInAt(payload),
		entry: payload?.entry || null,
		elapsedSeconds: Number(payload?.elapsed_seconds || 0),
	};
}
